import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const Retreat2024 = () => {
  return (
    <div className="min-h-screen bg-[#F9F7F2] text-[#3F2A24]">
      {/* Header */}
      <header className="px-6 pt-8 pb-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link
            to="/"
            className="text-sm text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
          >
            ← Retour à l'accueil
          </Link>
          <p className="text-xs tracking-[0.25em] uppercase text-[#8C6A4A]">
            Valouse 2024
          </p>
        </div>
      </header>

      {/* Hero image */}
      <section className="px-6">
        <div className="max-w-5xl mx-auto overflow-hidden rounded-3xl shadow-sm">
          <img
            src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/0bpjn0lq_Valouse%20Olives%20Drome%20Provencale.jpg"
            alt="Oliviers de la Drôme Provençale - Valouse 2024"
            className="w-full h-[50vh] object-cover"
          />
        </div>
      </section>

      {/* Content */}
      <section className="px-6 py-12">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <div className="space-y-3">
            <p className="text-xs tracking-[0.35em] uppercase font-medium text-[#8C6A4A]">
              COCON VALOUSE 2024
            </p>
            <h1 className="font-serif text-3xl md:text-4xl text-[#3F2A24]">
              Retour sur la retraite fondatrice
            </h1>
          </div>

          <p className="text-sm md:text-base leading-relaxed text-[#4B3329]">
            En 2024, <span className="italic uppercase">COCON</span> a pris forme dans la matière.<br />
            Des cercles fondateurs, intimes et sincères, où le cocon s'est tissé pas à pas.<br />
            Un espace pour honorer ce qui a été vécu, garder une trace sensible de ce moment fondateur<br />
            et permettre aux coconé·e·s d'y revenir quand le cœur en a besoin.
          </p>
        </div>
      </section>

      {/* Vidéo Valouse 2024 - Mini-Ateliers */}
      <section className="py-8 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#3F2A24] rounded-2xl overflow-hidden shadow-lg">
            <div className="px-6 py-5 text-center">
              <h2 className="text-sm md:text-base tracking-[0.25em] uppercase font-medium text-[#C5A059]">
                Valouse 2024 · Mini-Ateliers
              </h2>
            </div>
            <div className="relative w-full" style={{ aspectRatio: '16/9' }}>
              <video
                className="w-full h-full object-cover"
                controls
                playsInline
                preload="metadata"
                data-testid="video-mini-ateliers-2024"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/gjpiilmf_Pre%CC%81sentation%20des%20Mini-Ateliers.mp4" 
                  type="video/mp4" 
                />
                Votre navigateur ne supporte pas la lecture vidéo.
              </video>
            </div>
            <div className="px-6 py-4 text-center">
              <p className="text-sm text-[#E8D2B5]/80 italic">
                Présentation des Mini-Ateliers
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Galerie Photos COCON 2024 - Kilian Fermond */}
      <section className="py-10 px-0 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 mb-8 text-center">
          <h2 className="text-sm md:text-base tracking-[0.25em] uppercase font-medium text-[#3F2A24]">
            COCON 2024 · En images
          </h2>
          <p className="text-sm text-[#5C4A3D]/70 mt-3 italic">
            Sous l'œil de notre photographe attitré Kilian Fermond
          </p>
        </div>
        <div className="relative">
          <style>{`
            @keyframes gallery-scroll-2024 {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .gallery-2024-track {
              animation: gallery-scroll-2024 75s linear infinite;
            }
            .gallery-2024-track:hover {
              animation-play-state: paused;
            }
          `}</style>
          <div className="gallery-2024-track flex gap-4" style={{ width: 'max-content' }}>
            {/* First set of 15 images */}
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/zb7q1mgj_DSC07959.jpg" 
                alt="Retraite COCON Valouse 2024 - Moment de joie entre participantes Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/fkhaa4c5_DSC05738.jpg" 
                alt="Hameau de Valouse - Terrasse provençale retraite COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/pwk56qez_DSC07684.jpg" 
                alt="Cercle de femmes retraite COCON Valouse - Partage et connexion"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/cr23dmbz_DSC05705.jpg" 
                alt="Tote bag COCON - Retraite transformation féminine Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/8trkqev9_DSC05444.jpg" 
                alt="Oracle Féminité Sacrée - Atelier retraite COCON Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/19kzi9o7_DSC05995.jpg" 
                alt="Portrait nature lavande - Retraite COCON Valouse femmes"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/oaeffgbg_DSC05608.jpg" 
                alt="Méditation guidée retraite COCON Valouse - Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/4tr4xr60_DSC07342.jpg" 
                alt="Atelier plein air Hameau Valouse - Retraite transformation COCON"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/xisbg229_DSC05696.jpg" 
                alt="Hameau de Valouse Drôme - Lieu retraite COCON France"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/fx05xzk3_DSC05459.jpg" 
                alt="Instruments sacrés harmonium - Voyage sonore retraite COCON Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/locf9ljy_DSC05995.jpg" 
                alt="Portrait participante nature - Retraite féminine COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/4ad1821u_DSC05706.jpg" 
                alt="Rencontres et échanges - Cercle femmes retraite COCON Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/nspty2mh_DSC06078.jpg" 
                alt="Yoga matinal retraite COCON Valouse - Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/gk5qmdzy_DSC07148.jpg" 
                alt="Mas provençal Valouse - Architecture retraite COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/scg1t8hd_DSC07184.jpg" 
                alt="Connexion féminine mouvement - Retraite COCON Valouse France"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            {/* Duplicate set for seamless loop */}
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/zb7q1mgj_DSC07959.jpg" 
                alt="Retraite COCON Valouse 2024 - Moment de joie entre participantes Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/fkhaa4c5_DSC05738.jpg" 
                alt="Hameau de Valouse - Terrasse provençale retraite COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/pwk56qez_DSC07684.jpg" 
                alt="Cercle de femmes retraite COCON Valouse - Partage et connexion"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/cr23dmbz_DSC05705.jpg" 
                alt="Tote bag COCON - Retraite transformation féminine Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/8trkqev9_DSC05444.jpg" 
                alt="Oracle Féminité Sacrée - Atelier retraite COCON Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/19kzi9o7_DSC05995.jpg" 
                alt="Portrait nature lavande - Retraite COCON Valouse femmes"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/oaeffgbg_DSC05608.jpg" 
                alt="Méditation guidée retraite COCON Valouse - Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/4tr4xr60_DSC07342.jpg" 
                alt="Atelier plein air Hameau Valouse - Retraite transformation COCON"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/xisbg229_DSC05696.jpg" 
                alt="Hameau de Valouse Drôme - Lieu retraite COCON France"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/fx05xzk3_DSC05459.jpg" 
                alt="Instruments sacrés harmonium - Voyage sonore retraite COCON Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/locf9ljy_DSC05995.jpg" 
                alt="Portrait participante nature - Retraite féminine COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/4ad1821u_DSC05706.jpg" 
                alt="Rencontres et échanges - Cercle femmes retraite COCON Valouse"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/nspty2mh_DSC06078.jpg" 
                alt="Yoga matinal retraite COCON Valouse - Drôme Provençale"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/gk5qmdzy_DSC07148.jpg" 
                alt="Mas provençal Valouse - Architecture retraite COCON Drôme"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-shrink-0 w-72 h-72 md:w-80 md:h-80 rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/scg1t8hd_DSC07184.jpg" 
                alt="Connexion féminine mouvement - Retraite COCON Valouse France"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Matériel de Coaching - PRE-COCON */}
      <section className="py-12 px-6 bg-[#E8D2B5]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-sm md:text-base tracking-[0.25em] uppercase font-medium text-[#3F2A24] mb-4">
            Préparation · PRE-COCON
          </h2>
          <p className="text-sm text-[#5C4A3D]/70 mb-8 italic">
            Le travail de préparation avant la retraite
          </p>
          <a
            href="#"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#3F2A24]/10 border border-[#3F2A24]/30 text-[#3F2A24] text-sm hover:bg-[#3F2A24]/20 transition-colors"
            data-testid="pre-cocon-2024"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            PRE-COCON · Valouse 2024
          </a>
        </div>
      </section>

      {/* Matériel de Coaching - POST-COCON */}
      <section className="py-12 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-sm md:text-base tracking-[0.25em] uppercase font-medium text-[#3F2A24] mb-4">
            Intégration · POST-COCON
          </h2>
          <p className="text-sm text-[#5C4A3D]/70 mb-8 italic">
            Le travail d'intégration après la retraite
          </p>
          <a
            href="#"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#3F2A24]/10 border border-[#3F2A24]/30 text-[#3F2A24] text-sm hover:bg-[#3F2A24]/20 transition-colors"
            data-testid="post-cocon-2024"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            POST-COCON · Valouse 2024
          </a>
        </div>
      </section>

      {/* Call to action */}
      <section className="py-12 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#3F2A24] text-[#F3E5CF] text-sm tracking-[0.15em] uppercase shadow-md hover:bg-[#C5A059] hover:text-[#3F2A24] transition-colors duration-300"
          >
            Découvrir les retraites 2026
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Retreat2024;
